module Tapas.Bindings {
    export class Articles {
        public init(element: any, valueAccessor: () => any, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;

            $(".article-search").on("click", function () {
                const allArticlesPageId = $("#allarticlespageid").val();
                const articleSearchTerm = $("#articlesearchterm").val();
                document.location.href = "/default.aspx?id=" + allArticlesPageId + "&Title=*" + articleSearchTerm + "*";
            });


            $("#articlesearchterm").keyup(function (e) {
                if (e.keyCode == 13) {
                    $(".article-search").click();
                }
            });

        }
    }
    ko.bindingHandlers['articles'] = new Articles();
}